const vite = typeof import.meta !== 'undefined'
  && import.meta.env
  && import.meta.env.VITE_API_BASE_URL;
const next = process.env.NEXT_PUBLIC_API_BASE_URL;
const cra  = process.env.REACT_APP_API_URL;

export const API_BASE = vite || next || cra || 'http://localhost:5001/api';

if (typeof window !== 'undefined') window.API_BASE = API_BASE; //